import React from 'react'
import styles from './SlimFirstView.module.css'
import { SlimFirstViewProps } from './types'

const IMAGES = {
    slimFirstView: '/pages/abtest/dev3366/firstview_slim.jpg',
}

// DEV-3366のFV訴求変更ABCテストで導入し、DEV-3419でCパターン採用により恒久化した
// 高さ73pxの帯。対象ページでは現行FirstView(ヒーロー画像)の代わりに常時表示する。
// AB判定は持たない（画像パスの dev3366 はテスト当時の配置をそのまま使っている）。
export const SlimFirstView = ({ dataViewLabel }: SlimFirstViewProps) => {
    return (
        <section data-view-label={dataViewLabel}>
            <div className={styles.contentWrap}>
                <img
                    src={IMAGES.slimFirstView}
                    alt='飲食店正社員 求人数No.1 ※'
                    width={375}
                    height={73}
                />
            </div>
        </section>
    )
}

export default SlimFirstView
